/**
 * Cancel auto-segmentation proposal card (the runtime HITL gate) for
 * `cancel_auto_segmentation`. Pure presentational: it shows the job (model,
 * current status, start time); nothing happens until the clinician presses
 * Apply, which runs the same steps as the Job Queue panel's Cancel button.
 * Frame, status chip and Apply/Reject live in {@link ProposalCardShell}.
 */
import { Typography } from '@mui/material';
import ProposalCardShell, {
    ProposalSummaryBox,
    type ProposalStatus,
} from './ProposalCardShell';

export interface CancelAutoSegmentationProposalCardProps {
    readonly model: string;
    readonly jobStatus: string;
    /** Epoch ms. */
    readonly startedAt: number;
    readonly status: ProposalStatus;
    readonly failureReason?: string;
    readonly onApply: () => void;
    readonly onReject: () => void;
    readonly onPreviewEnter: () => void;
    readonly onPreviewLeave: () => void;
}

export default function CancelAutoSegmentationProposalCard({
    model,
    jobStatus,
    startedAt,
    status,
    failureReason,
    onApply,
    onReject,
    onPreviewEnter,
    onPreviewLeave,
}: CancelAutoSegmentationProposalCardProps) {
    return (
        <ProposalCardShell
            title="Cancel auto-segmentation"
            ariaLabel="Cancel auto-segmentation proposal"
            status={status}
            failureReason={failureReason}
            onApply={onApply}
            onReject={onReject}
            onPreviewEnter={onPreviewEnter}
            onPreviewLeave={onPreviewLeave}
        >
            <ProposalSummaryBox>
                cancel Contour+ job <strong>{model || 'unknown model'}</strong>
                <br />
                {jobStatus} · started {new Date(startedAt).toLocaleTimeString()}
            </ProposalSummaryBox>
            <Typography variant="caption" color="text.secondary">
                Same as Cancel in the Job Queue. No contours are created for
                this job.
            </Typography>
        </ProposalCardShell>
    );
}
